import { Controller } from "stimulus"
const timeout = 1000 * 60;
export default class extends Controller {
  static get targets() {
    return ['time'];
  }


  initialize(){
    let time = parseInt(this.data.get('minutes'),10);
    this.showTime(time);
    if(time > 1.0){
      setTimeout(this.fixTime(this), timeout);
    }
  }

  fixTime(t){
    return () => {
    let time = parseInt(t.data.get('minutes'),10);
    this.data.set('minutes', time - 1);
      if(this.showTime(time - 1)){
        setTimeout(t.fixTime(t), timeout);
      }
    }
  }

  showTime(time){
    if(time < 1.0){
      this.element.style.visibility = 'hidden';
      return false;
    }
    else
    {
      this.element.style.visibility = 'visible';
      let hours = Math.floor((time / 60));
      let hour_display = "";
      if( hours > 0) {

        hour_display = hours + " hour";

        if(hours > 1){
          hour_display += "s";
        }

        hour_display += ", ";
      }
      let minutes_after = time % 60;

      let minute_display = "";

      if(minutes_after > 0){
        minute_display = minutes_after + " minutes"
      }

      this.timeTarget.innerText = hour_display + minute_display ;
      return true;
    }
  }

}
